import { render } from "./LoadingPropsCmp.vue?vue&type=template&id=51234442"
import script from "./LoadingPropsCmp.vue?vue&type=script&lang=js"
export * from "./LoadingPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__